var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"contents"}},[_c('v-date-field',{attrs:{"color":_vm.color,"value-format":_vm.valueFormat,"value":_vm.since},on:{"input":_vm.sinceChanged}}),_c('v-date-field',{attrs:{"color":_vm.color,"value-format":_vm.valueFormat,"value":_vm.until},on:{"input":_vm.untilChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }